import { Injectable } from '@angular/core';

import { Item } from './item';
import { ITEMS } from './items';
import { MOCKITEMS } from './mock-items';

@Injectable()
export class ItemsService {

  getItems(): Promise<Item[]> {
    return Promise.resolve(ITEMS);
  }

  getMockItems(): Promise<Item[]> {
    return Promise.resolve(MOCKITEMS);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/transition-matrix/items/items.service.ts